import React, { FC } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';

import { Loader } from '@eika/loader';

import Barn from '../components/barn/barn';
import Biler from '../components/bil/biler';
import Egenkapital from '../components/egenkapital/egenkapital';
import Gjeld from '../components/gjeld/gjeld';
import Inntekt from '../components/inntekt/inntekt';
import Medlaantaker from '../components/medlaantaker/medlaantaker';
import Kvittering from '../components/oppsummering/kvittering';
import Oppsummering from '../components/oppsummering/oppsummering';
import {
    PAGE_BARN_URL,
    PAGE_BILER_URL,
    PAGE_EGENKAPITAL_URL,
    PAGE_GJELD_URL,
    PAGE_INNTEKT_URL,
    PAGE_KVITTERING_URL,
    PAGE_OPPSUMMERING_URL,
    PAGE_ROOT,
    PAGE_SAMTYKKE_URL,
    PAGE_VEDLEGG_URL,
} from '../components/page/pageUrl';
import Samtykke from '../components/samtykke/samtykke';
import Vedlegg from '../components/vedlegg/vedlegg';
import { SoeknadstypeWeb } from '../generated-types';
import useFeatureToggle from '../hooks/useFeatureToggle';
import ScrollToTop from '../util/scrollToTop';
import AppContextContainer from './appContextContainer';

const soeknadstype = SoeknadstypeWeb.MEDLAANTAKER;
const appNameSpace = 'kreditt.boliglaansoeknad.medlaantaker-view';

const MedlaantakerRouting: FC = () => {
    const { data: featureToggles, isPending } = useFeatureToggle();
    const { utvideDatagrunnlag } = featureToggles || {};

    return isPending ? (
        <Loader />
    ) : (
        <AppContextContainer
            appName={appNameSpace}
            soeknadtype={soeknadstype}
            featureToggleUtvideDatagrunnlag={utvideDatagrunnlag}
        >
            <HashRouter>
                <ScrollToTop />
                <Routes>
                    <Route
                        path={PAGE_ROOT}
                        element={<Medlaantaker soeknadstype={soeknadstype} navigateTo={PAGE_SAMTYKKE_URL} />}
                    />
                    <Route
                        path={PAGE_SAMTYKKE_URL}
                        element={<Samtykke navigateTo={PAGE_INNTEKT_URL} navigateFrom={PAGE_ROOT} />}
                    />
                    <Route
                        path={PAGE_INNTEKT_URL}
                        element={
                            <Inntekt
                                navigateTo={utvideDatagrunnlag ? PAGE_BILER_URL : PAGE_BARN_URL}
                                navigateFrom={PAGE_SAMTYKKE_URL}
                            />
                        }
                    />
                    <Route
                        path={PAGE_BILER_URL}
                        element={<Biler navigateTo={PAGE_BARN_URL} navigateFrom={PAGE_INNTEKT_URL} />}
                    />
                    <Route
                        path={PAGE_BARN_URL}
                        element={
                            <Barn
                                navigateTo={PAGE_GJELD_URL}
                                navigateToOption={PAGE_EGENKAPITAL_URL}
                                navigateFrom={utvideDatagrunnlag ? PAGE_BILER_URL : PAGE_INNTEKT_URL}
                            />
                        }
                    />
                    <Route
                        path={PAGE_EGENKAPITAL_URL}
                        element={<Egenkapital navigateTo={PAGE_GJELD_URL} navigateFrom={PAGE_BARN_URL} />}
                    />
                    <Route
                        path={PAGE_GJELD_URL}
                        element={
                            <Gjeld
                                navigateTo={PAGE_VEDLEGG_URL}
                                navigateFrom={PAGE_BARN_URL}
                                navigateFromOption={PAGE_EGENKAPITAL_URL}
                            />
                        }
                    />
                    <Route
                        path={PAGE_VEDLEGG_URL}
                        element={<Vedlegg navigateTo={PAGE_OPPSUMMERING_URL} navigateFrom={PAGE_GJELD_URL} />}
                    />
                    <Route
                        path={PAGE_OPPSUMMERING_URL}
                        element={<Oppsummering navigateTo={PAGE_KVITTERING_URL} navigateFrom={PAGE_VEDLEGG_URL} />}
                    />
                    <Route path={`${PAGE_KVITTERING_URL}/:soeknadId`} element={<Kvittering />} />
                </Routes>
            </HashRouter>
        </AppContextContainer>
    );
};

export default MedlaantakerRouting;
